import { useEffect, useState } from 'react';
import axios from 'axios';

function useUsedVsUnused() {
  const [used, setUsed] = useState([]);
  const [unused, setUnused] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sessionID = localStorage.getItem('sessionId');
    const authToken = localStorage.getItem('authToken');

    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/analytics/used-vs-unused`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'x-session-id': sessionID,
      }
    })
    .then(res => {
      setUsed(res.data.used || []);
      setUnused(res.data.unused || []);
    })
    .catch(console.error)
    .finally(() => setLoading(false));
  }, []);

  return { used, unused, loading };
}

export default useUsedVsUnused;